import React from 'react';
import withApollo from '../lib/apollo';

import ResetPassword from '../components/ResetPassword';
import { useSiteContext } from '../components/SiteContext';

const ResetPasswordPage = () => {
  const { dashboard } = useSiteContext();
  return <ResetPassword showBreadcrumbs={!dashboard} />;
};

export default withApollo(ResetPasswordPage);
